<div class="winnerImage" [routerLink]="['/game/feedback']"></div>
